import { Stack } from '@grubhubprod/gh-cookbook-react';
import React from 'react';
import { useParams } from 'react-router-dom';
import { MealCreditController } from 'src/components/oneCorp/features/MealCredit/components/DetailsPage/MealCreditController/MealCreditController';
import { MealCreditHeader } from 'src/components/oneCorp/features/MealCredit/components/Headers/MealCreditHeader';

export function MealCreditEditDetailsPage(): JSX.Element {
  const { corpid: corpId, mealCreditId } =
    useParams<{ corpid: string; mealCreditId: string }>();

  return (
    <>
      <Stack y="lg">
        <MealCreditHeader corpId={corpId} mealCreditId={mealCreditId} />
      </Stack>
      <MealCreditController corpId={corpId} mealCreditId={mealCreditId} />
    </>
  );
}
